<template>
	<form @submit.prevent="startSubmit($event)">
		<smart-input
			v-model="form.name"
			required
			:error="inputErrors.name"
			label="שם המשחק"
		/>
		<v-select
			v-model="form.company_id"
			v-can="['admin', 'manager']"
			:items="companies"
			item-text="name"
			item-value="id"
			label="מרכז"
		/>
		<v-select
			v-model="form.type_id"
			:required="true"
			:error-messages="inputErrors.type_id"
			:items="types"
			item-text="name"
			item-value="id"
			label="סוג משחק"
			:disabled="!isNew"
		/>

		<p>{{ type.description && Object.values(type.description).length > 0 ? type.description : "" }}</p>

		<media-gallery-preview
			v-model="form.media_id"
			:image-url="game.logo"
		/>

		<tags-select
			v-model="form.newTags"
			:initial-tags="form.tags"
		/>
		<v-switch
			v-if="organization.can_share"
			v-model="form.share"
			:error="inputErrors.public"
			label="אפשר להציג את המשחק גם מחוץ למערכת"
			class="mx-2"
		/>
		<v-switch
			v-if="isManager"
			v-model="form.public"
			:error="inputErrors.public"
			label="פתוח לכולם"
			class="mx-2"
		/>

		<v-expansion-panels>
			<v-expansion-panel>
				<v-expansion-panel-header>
					הגדרות מתקדמות
				</v-expansion-panel-header>
				<v-expansion-panel-content>
					<smart-input
						v-model="form.f_pixel"
						:error="inputErrors.f_pixel"
						hint="אם אינך יודע מה זה. השאר ריק"
						label="Facebook Pixel"
						name="f_pixel"
					/>
					<smart-input
						v-model="form.google_tag"
						:error="inputErrors.google_tag"
						hint="אם אינך יודע מה זה. השאר ריק"
						label="Google Tag"
						name="google_tag"
					/>
				</v-expansion-panel-content>
			</v-expansion-panel>
		</v-expansion-panels>

		<div class="form-group mt-5">
			<v-btn
				type="submit"
				color="success"
			>
				שמירה
			</v-btn>
		</div>
	</form>
</template>

<script>
import GameModule from "src/store/modules/Game.module";
import FormView from "src/mixins/FormView";
import { types as TypesTypes } from "src/store/modules/Type.module";
import { types as CompaniesTypes } from "src/store/modules/Company.module";
import TagsSelect from "root/packages/closeapp/QuestionsManager/assets/views/questions/TagsSelect.vue";
import MediaGalleryPreview from "../../packages/gallery/MediaGalleryPreview";

export default {
	name: "GameForm",
	components: { MediaGalleryPreview, TagsSelect },
	props: [],
	data () {
		return {
			form: {
				name: null,
				share: true,
			},
			type: {},
		};
	},
	mixins: [new FormView(GameModule, "game")],
	computed: {
		isNew () {
			return !(this.game && this.game.id);
		},
		companies () {
			return this.$store.state.CompanyModule.companies;
		},
		types () {
			return this.$store.state.TypeModule.types.filter((type) => type.active);
		},
		isManager () {
			return this.$store.getters.isManager;
		},
		organization () {
			return this.$store.state.CurrentOrg.organization;
		},
	},
	watch: {
		"form.type_id": {
			handler (val) {
				this.type = this.types.find(type => type.id === val);
			},
			deep: true,
		},
		"form.newTags": {
			handler () {
				if (this.game.tags && this.game.tags.length > 0) {
					this.form.tags.concat(this.game.tags);
				}
			},
			immediate: true,
		},

	},
	created () {
		this.$store.dispatch(TypesTypes.FETCH);
		this.$store.dispatch(CompaniesTypes.FETCH);
	},
	methods: {
		startSubmit (e) {
			// ! important = FormView.js should be modified so that data sent to server could be changed without modifying this.form
			// ! in case request fails etc.
			// if (this.form.newTags && this.form.newTags.length > 0) {
			// 	this.form.newTags = this.form.newTags.filter(val => !this.form.tags.includes(val));
			// }
			this.onSubmit(e);
		},
		onReset () {
			this.$emit("clear-errors");
		},
	},
};
</script>

<style>
</style>
